<template>
    <div>
        <v-card-text>
            <treasure-table
                :items="treasures"
                :options="pagination"
                @edit="openEditTreasurePanel"/>

            <right-panel
                ref="editTreasurePanel"
                :title="$t('treasureHunt.detail.header')">
                <template v-slot:content="{ context }">
                    <treasure-detail-view
                        ref="treasureDetailView"
                        :treasure="context"/>
                </template>

                <template v-slot:bottom>
                    <v-spacer/>
                    <v-btn
                        width="120px"
                        color="primary"
                        @click="onEditTreasureSave">
                        {{ $t('button.save') }}
                    </v-btn>
                </template>
            </right-panel>
        </v-card-text>
    </div>
</template>

<script>
import TreasureTable from '@/components/tables/TreasureTable'
import TreasureDetailView from '@/views/details/TreasureDetailView'
import RightPanel from '@/components/panels/RightPanel'

import { mapGetters } from 'vuex'

export default {
    name: 'TreasureListView',

    props: {
        treasures: {
            type: Array,
            default: () => []
        },

        pagination: {
            type: Object,
            default: () => ({})
        }
    },

    components: {
        TreasureTable,
        RightPanel,
        TreasureDetailView
    },

    computed: {
        ...mapGetters({
            getTreasureById: 'treasureHunt/getTreasureById'
        })
    },

    methods: {
        openEditTreasurePanel (item) {
            const treasure = this.getTreasureById(item.id)

            if (treasure) {
                this.$refs.editTreasurePanel.open(treasure)
            }
        },

        closeEditTreasurePanel () {
            this.$refs.editTreasurePanel.close()
        },

        async onEditTreasureSave () {
            await this.$refs.treasureDetailView.save()
            this.closeEditTreasurePanel()
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
